import DivisionPage from "@/components/DivisionPage";
import { DIVISIONS } from "@/data/divisions";

export default function Protocolo() {
  return <DivisionPage division={DIVISIONS.protocolo} />;
}
